import React from "react"
import styles from "./styles.module.scss"
import * as Sentry from "@sentry/react"
import { ModalWrapper } from "../ModalWrapper"
import CloseModalButton from "../../buttons/CloseModalButton"

export class ErrorBoundary extends React.Component<
  { children: React.ReactNode },
  { hasError: boolean }
> {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  componentDidCatch(error, errorInfo) {
    Sentry.captureException(error, { extra: errorInfo })
  }

  render() {
    return (
      <>
        {this.state.hasError && (
          <ModalWrapper>
            <div className={styles.errorBoundaryContainer}>
              <div className={styles.errorBoundaryCloseButton}>
                <CloseModalButton
                  onClick={() => {
                    this.setState({ hasError: false })
                  }}
                />
              </div>
              <h1 className={styles.errorBoundaryTitle}>Oops! Something went wrong</h1>
              <p className={styles.errorBoundaryMessage}>
                We apologize for the inconvenience. Cruisen team has been notified of this error.
                Please try refreshing the page.
              </p>
              <button
                onClick={() => window.location.reload()}
                className={styles.errorBoundaryButton}
              >
                Refresh Page
              </button>
            </div>
          </ModalWrapper>
        )}
        {this.props.children}
      </>
    )
  }
}
